module.exports = __webpack_public_path__ + "img/icon_nav1.b222da82.cd71a279.svg";